const NODES = [
  { date: 'Week 0', phase: 'Registration', desc: 'Registration with idea submission, September 16–29' },
  {
    date: 'Oct 1',
    phase: 'Kickoff',
    desc: 'Virtual kick-off with a webinar on "How to Build with AI" by Leapfrog AI Center of Excellence (AI CoE)'
  },
  {
    date: 'Week 1',
    phase: 'Explore',
    desc: 'Ideation and problem identification'
  },
  {
    date: 'Weeks 2–3',
    phase: 'Build',
    desc: 'Agent development, experimentation, open-source contribution & mentoring',
    hi: true
  },
  {
    date: 'Week 4',
    phase: 'Showcase',
    desc: 'Finalization, documentation, demos & project presentations'
  },
  { date: 'Week 4', phase: 'Shortlist', desc: 'Evaluate and shortlist top 5 teams for demo' },
  {
    date: 'Oct 30',
    phase: 'Demo Day',
    desc:
      'Evaluation, winner selection & recognition. At least one (1) member from the team should be physically present in Kathmandu valley for this.',
    hi: true
  }
];

export default NODES;
